import { TradingSearchResult } from '../../../replicant/features/tradingMeme/tradingMeme.properties';
import { Optional } from '../../types';
import { dedupArray } from '../../utils';
import { MemeList } from './MemeList';

export class UserMemeList extends MemeList {
  override search = async (searchString: string) => {
    const tokens = this.list.filter((t) => {
      const l = this.getItem(t.id);
      return (
        l.name.includes(searchString) || l.creatorName.includes(searchString)
      );
    });

    this.updateListing(tokens, true);
  };

  override paginate = async () => {
    // there's no pagination; We always fetch all tokens (maybe one day we will need)
  };

  override requestUpdate = async (refresh: Optional<'refresh'> = undefined) => {
    if (refresh) {
      await this.requestListing(Boolean(refresh));
    }
  };

  private getMyTokens = async (): Promise<TradingSearchResult[]> => {
    await this.app.profile.isReady;

    if (!this.app.profile.current) {
      return [];
    }

    const isFarming = this.filter === 'Farming';
    const isOwned = this.filter === 'Owned';

    const key = isOwned
      ? 'tokensOwned'
      : this.filter === 'Created'
      ? 'tokensCreated'
      : isFarming
      ? 'tokensFarming'
      : undefined;

    if (!key) {
      return [];
    }

    if (isFarming) {
      const walletWithPoints = dedupArray([
        ...this.app.profile.current.pointsOwned,
        ...this.app.profile.current[key],
      ]);

      return walletWithPoints;
    }

    return this.app.profile.current[key];
  };

  override requestListing = async (reset = false) => {
    const myTokens: { id?: string; tokenId?: string }[] =
      await this.getMyTokens();

    const ids = myTokens
      .map((t) => t.id ?? t.tokenId)
      .filter(Boolean) as string[];

    const tokens =
      ids.length > 0
        ? await this.app.asyncGetters.getMemesFromOpenSearch({
            memeIds: ids,
          })
        : [];

    return this.updateListing(tokens, reset);
  };
}
